import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, KeyValues10, KeyValueSet, LocalService, Status, TriggeredEvent, Wrapper10 } from '../../../service/local.service';
import { MenuManagementService } from '../../../service/menu-management.service';

@Component({
  selector: 'app-menu-configuration',
  templateUrl: './menu-configuration.component.html',
  styleUrls: ['./menu-configuration.component.scss']
})
export class MenuConfigurationComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["menu_popup"];
  wrapper: Wrapper10; message: string = ''; isRedAlert: boolean = true;
  id: string; isPublic = false; isInternal = false; maxBodyHeight = 0;
  htmlId: string = ''; elementIds: any;

  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, private menuManagementService: MenuManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      name: 'menu_name_' + this.htmlId,
      first_name: 'menu_name_' + this.htmlId + '_m'
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id == '') {
      this.onLoadNextOrder();
    }
    else {
      this.menuManagementService.getMenu(this.id).subscribe(result => {
        this.wrapper = result;
        this.isPublic = this.wrapper.content.v4 == '1';
        this.isInternal = this.wrapper.content.v7 == '1';
      });
    }
  }

  onLoadNextOrder() {
    if (this.id == '') {
      this.menuManagementService.getNextOrder(this.wrapper && this.wrapper.content ? this.wrapper.content.v1 : '').subscribe(result => {
        if (this.wrapper && this.wrapper.content) {
          this.wrapper.content.v2 = result;
        } else {
          this.wrapper = {
            content: { key: '', v1: '', v2: result, v5: '', v3: '', v4: this.isPublic ? '1' : '0', v6: '0', v7: this.isInternal ? '1' : '0' } as KeyValues10
          } as Wrapper10;
        }
      });
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    if (this.doCheck()) {
      this.wrapper.content.v4 = this.isPublic ? '1' : '0';
      this.wrapper.content.v7 = this.isInternal ? '1' : '0';
      this.menuManagementService.saveMenu(this.wrapper).subscribe(result => {
        if (result.status == Status.Success) {
          this.wrapper.content.key = this.id == '' ? result.id : this.id;
          this.activeModal.close({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
        }
      });
    }
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.wrapper.languageContents = languageContents;
  }

  getAvailableParentMenus(): KeyValueSet[] {
    let menus: KeyValueSet[] = [];
    if (this.localService.loggedMember.allowedMenus && this.localService.loggedMember.allowedMenus.find(x => x.businessId == this.localService.getSelectedBusinessId())?.menus.length > 0) {
      this.localService.loggedMember.allowedMenus.find(x => x.businessId == this.localService.getSelectedBusinessId())?.menus.filter(x => x.menu.v1 == '' && x.menu.key != this.id).forEach(x => {
        menus.push({ key: x.menu.key, value: x.menu.v5 } as KeyValueSet);
      });
    }
    return menus;
  }

  doCheck() {
    let message = '';
    if (!this.wrapper.languageContents || this.wrapper.languageContents.filter(x => x.v3 != '').length == 0) {
      message = this.localService.languageContent.menu_popup.need_name;
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
    }
    this.message = message;
    return message == '';
  }
}
